// src/components/CustomerSummary/Constants/sectionKeys.js

const SECTION_KEYS = [
  'studiesStarted',
  'studiesStartedWorkflowDistribution',
  'finalizedStudies',
  'finalizedStudiesWorkflowDistributions',
  'urgentEmergentNotifications',
  'turnaroundTimes',
  'averageStudyLength',
  'deviceUtilization',

  'supportTicketsResolved',
  'top3StudyIndications',
  'top3OrderingProviders',
  'payerMix',
  'patientStats',
];
export default SECTION_KEYS;
